import { Injectable } from '@angular/core';

import { patch } from '@ngxs/store/operators';
import { Action, Selector, State, StateContext } from '@ngxs/store';

import { REWARDFUL_STATE_TOKEN, RewardfulStateModel } from './rewardful-state.models';
import { GetRewardfulInfo } from './rewardful-state.actions';

@Injectable()
@State<RewardfulStateModel>({
  name: REWARDFUL_STATE_TOKEN,
  defaults: {
    referralId: null,
    couponId: null,
    couponName: null,
    couponDuration: null,
    couponPercentOff: null,
    affiliateId: null,
    affiliateName: null,
    campaignId: null,
    campaignName: null,
  },
})
export class RewardfulState {
  @Selector()
  static info(data: RewardfulStateModel): RewardfulStateModel {
    return data;
  }

  @Action(GetRewardfulInfo)
  getRewardfulInfo({ setState }: StateContext<RewardfulStateModel>): unknown {
    const payload = {
      referralId: Rewardful.referral,
      couponId: Rewardful.coupon?.id,
      couponName: Rewardful.coupon?.name,
      couponDuration: Rewardful.coupon?.duration,
      couponPercentOff: Rewardful.coupon?.percent_off?.toString(),
      affiliateId: Rewardful.affiliate?.id,
      affiliateName: Rewardful.affiliate?.name,
      campaignId: Rewardful.campaign?.id,
      campaignName: Rewardful.campaign?.name,
    };

    return setState(patch(payload));
  }
}
